import React, { useRef, useState } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";

import { AnimatePresence } from "framer-motion";
/* ================= IMAGE ================= */
import heroImg from "../assets/contact-hero.jpg";

const ContactPage = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);

  const [active, setActive] = useState(null);


  return (
    <div className="bg-[#F6F2EF] text-gray-800">

{/* ================= HERO ================= */}
<section className="relative h-[80vh] overflow-hidden flex items-center justify-center">

  <motion.img
    src={heroImg}
    style={{ y }}
    className="absolute inset-0 w-full h-full object-cover scale-110"
    alt="Zewelra"
  />

  <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/70" />

  <div className="absolute w-96 h-96 rounded-full bg-[#e7b6a1]/20 blur-3xl top-10 left-10" />
  <div className="absolute w-80 h-80 rounded-full bg-white/10 blur-3xl bottom-10 right-10" />

  <motion.div
    initial={{ opacity: 0, y: 60 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
    className="relative z-10 text-center text-white"
  >
    <p className="uppercase tracking-[6px] text-sm text-[#e7b6a1] mb-5">
      Contact Zewelra
    </p>

    <h1 className="text-6xl md:text-7xl font-serif leading-tight">
      We'd Love <br />
      <span className="text-[#e7b6a1]">
        To Hear From You
      </span>
    </h1>

    <p className="mt-8 max-w-xl mx-auto text-gray-200 leading-8">
      Whether you're looking for custom jewelry, order support,
      or luxury consultations, our team is always here to help.
    </p>
  </motion.div>

</section>
{/* ================= CONTACT ================= */}
<section
  ref={ref}
  className="relative py-24 px-6 md:px-20 overflow-hidden"
>
  {/* Background Blur */}
  <div className="absolute -top-24 -left-20 w-72 h-72 bg-[#e7b6a1]/20 rounded-full blur-3xl"></div>
  <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#f8d9cc]/30 rounded-full blur-3xl"></div>

  <div className="relative grid lg:grid-cols-2 gap-16 items-center">

    {/* ================= LEFT ================= */}
    <motion.div
      initial={{ opacity: 0, x: -70 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.8 }}
    >
      <p className="uppercase tracking-[4px] text-[#c89c85] text-sm mb-3">
        Contact Information
      </p>

      <h2 className="text-5xl font-serif mb-5 leading-tight">
        Let's <span className="text-[#e7b6a1]">Connect</span>
      </h2>

      <p className="text-gray-500 leading-8 mb-10">
        Whether you're looking for luxury jewelry, custom designs,
        or order support, our team is always here to help.
      </p>

      <div className="space-y-7">

        {/* Address */}
        <motion.div
          whileHover={{ scale: 1.03, y: -5 }}
          className="group bg-white rounded-3xl p-7 shadow-lg border border-transparent hover:border-[#e7b6a1]/40 hover:shadow-2xl transition-all"
        >
          <div className="flex gap-5">

            <div className="w-16 h-16 rounded-2xl bg-[#F6F2EF] flex items-center justify-center text-3xl shadow">
              📍
            </div>

            <div>
              <h3 className="font-semibold text-xl">
                Visit Our Boutique
              </h3>

              <p className="text-gray-500 mt-2">
                Patiala, Punjab, India
              </p>

              <button className="mt-4 text-[#e7b6a1] font-medium hover:underline">
                Get Directions →
              </button>
            </div>

          </div>
        </motion.div>

        {/* Email */}
        <motion.div
          whileHover={{ scale: 1.03, y: -5 }}
          className="group bg-white rounded-3xl p-7 shadow-lg border border-transparent hover:border-[#e7b6a1]/40 hover:shadow-2xl transition-all"
        >
          <div className="flex gap-5">

            <div className="w-16 h-16 rounded-2xl bg-[#F6F2EF] flex items-center justify-center text-3xl shadow">
              📧
            </div>

            <div>
              <h3 className="font-semibold text-xl">
                Email Support
              </h3>

              <p className="text-gray-500 mt-2">
                zewelra@gmail.com
              </p>

              <button className="mt-4 text-[#e7b6a1] font-medium hover:underline">
                Send Email →
              </button>
            </div>

          </div>
        </motion.div>

        {/* Phone */}
        <motion.div
          whileHover={{ scale: 1.03, y: -5 }}
          className="group bg-white rounded-3xl p-7 shadow-lg border border-transparent hover:border-[#e7b6a1]/40 hover:shadow-2xl transition-all"
        >
          <div className="flex gap-5">

            <div className="w-16 h-16 rounded-2xl bg-[#F6F2EF] flex items-center justify-center text-3xl shadow">
              📞
            </div>

            <div>
              <h3 className="font-semibold text-xl">
                Call Us
              </h3>

              <p className="text-gray-500 mt-2">
                +91 79738 91820
              </p>

              <p className="text-sm text-gray-400">
                Monday – Saturday | 10:00 AM – 7:00 PM
              </p>

              <button className="mt-4 text-[#e7b6a1] font-medium hover:underline">
                Call Now →
              </button>
            </div>

          </div>
        </motion.div>

      </div>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-6 mt-12">

        <div className="bg-white rounded-2xl shadow-md p-6 text-center">
          <h3 className="text-3xl font-bold text-[#e7b6a1]">
            10K+
          </h3>
          <p className="text-sm text-gray-500 mt-2">
            Happy Clients
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-6 text-center">
          <h3 className="text-3xl font-bold text-[#e7b6a1]">
            500+
          </h3>
          <p className="text-sm text-gray-500 mt-2">
            Custom Orders
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-6 text-center">
          <h3 className="text-3xl font-bold text-[#e7b6a1]">
            4.9★
          </h3>
          <p className="text-sm text-gray-500 mt-2">
            Customer Rating
          </p>
        </div>

      </div>

    </motion.div>

    {/* ================= MAP ================= */}
    <motion.div
      initial={{ opacity: 0, x: 70 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.8 }}
      className="overflow-hidden rounded-[30px] shadow-2xl border-4 border-white"
    >

      <iframe
        title="map"
        src="https://maps.google.com/maps?q=patiala&t=&z=13&ie=UTF8&iwloc=&output=embed"
        className="w-full h-[650px]"
      />

    </motion.div>

  </div>
</section>

{/* ================= CONTACT FORM ================= */}
<section className="py-24 px-6 md:px-20">

  <div className="max-w-5xl mx-auto text-center">

    <p className="uppercase tracking-[5px] text-[#c89c85]">
      CONTACT FORM
    </p>

    <h2 className="text-5xl font-serif mt-3">
      How Can We Help?
    </h2>

    <p className="text-gray-500 mt-5 max-w-2xl mx-auto">
      Fill out the form below and our jewelry consultant will
      contact you within 24 hours.
    </p>

  </div>

  <motion.div
    initial={{ opacity: 0, y: 80 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: .8 }}
    className="max-w-5xl mx-auto mt-14 bg-white rounded-[35px] shadow-2xl p-12 border border-[#e7b6a1]/20"
  >

    <div className="grid md:grid-cols-2 gap-7">

      <input
        type="text"
        placeholder="Full Name"
        className="rounded-xl border border-gray-200 px-5 py-4 outline-none focus:border-[#e7b6a1] focus:ring-2 focus:ring-[#e7b6a1]/30 transition"
      />

      <input
        type="email"
        placeholder="Email Address"
        className="rounded-xl border border-gray-200 px-5 py-4 outline-none focus:border-[#e7b6a1] focus:ring-2 focus:ring-[#e7b6a1]/30 transition"
      />

      <input
        type="text"
        placeholder="Phone Number"
        className="rounded-xl border border-gray-200 px-5 py-4 outline-none focus:border-[#e7b6a1] focus:ring-2 focus:ring-[#e7b6a1]/30 transition"
      />

      <select
        className="rounded-xl border border-gray-200 px-5 py-4 outline-none focus:border-[#e7b6a1] focus:ring-2 focus:ring-[#e7b6a1]/30 transition"
      >
        <option>Select Inquiry</option>
        <option>Order Support</option>
        <option>Custom Jewelry</option>
        <option>Repair Service</option>
        <option>Wholesale</option>
        <option>Other</option>
      </select>

    </div>

    <textarea
      rows="6"
      placeholder="Write your message..."
      className="mt-7 w-full rounded-xl border border-gray-200 px-5 py-4 outline-none focus:border-[#e7b6a1] focus:ring-2 focus:ring-[#e7b6a1]/30 transition"
    />

    <div className="text-center">

      <button
        className="mt-10 px-12 py-4 rounded-full bg-gradient-to-r from-black via-gray-900 to-black text-white font-medium hover:scale-105 hover:shadow-2xl transition-all duration-300"
      >
        Send Message →
      </button>

    </div>

  </motion.div>

</section>

    </div>
  );
};

export default ContactPage;